/* 
* 方法皆为过滤器
*/

export { parseTime } from '@/utils'

// 将字符串的第一字符变成大写
export const uppercaseFirstChar = (str: string) => {
    return str.charAt(0).toUpperCase() + str.slice(1)
}

/**
 * 时间戳转时间，具体到天
 * @param str 
 */
const stampTransDay = function (str: any, nowDate?: any) {
    var date: any

    if (nowDate) {
        date = str   // 当前时间
    } else {
        date = new Date(str * 1000) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
    }

    var Y = date.getFullYear() + '-'
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
    var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ''
    return Y + M + D
}


/**
 *  处理聊天界面的时间(接单系统)
*/
export const dealChatTime = function (time01: any, time02: any) {
    if (time01 && time02 && time02.time) {
        let nowDate = stampTransDay(new Date(), "nowDate") // 当前日期
        let timeDistance = Number(time01) - Number(time02.time); // 两条信息时间间距

        let arr = [time01, time02.time]
        let timeArr = []

        for (let item of arr) {
            let date = new Date(item * 1000)
            let Y = date.getFullYear()
            let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
            let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate())
            let h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
            let m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()

            timeArr.push([Y, M, D, h, m])
        }

        let item01 = `${timeArr[0][0]}${timeArr[0][1]}${timeArr[0][2]}`
        let item02 = `${timeArr[1][0]}${timeArr[1][1]}${timeArr[1][2]}`
        let item03 = `${timeArr[0][0]}`
        let item04 = `${timeArr[1][0]}`;

        if (timeDistance < (60 * 5)) {
            return ""
        } else {
            // 是否同天
            if (item01 == item02) {
                // 是否同年
                if (item03 == item04) {
                    // 是否为今年
                    if (nowDate.slice(0, 4) == item01.slice(0, 4)) {
                        // 是否为今天
                        if (nowDate == stampTransDay(time01)) {
                            let nowDay_time: any = new Date()
                            if (Date.parse(nowDay_time) - time01 * 1000 < 60 * 60 * 1000) {
                                if ((Date.parse(nowDay_time) - time01 * 1000) < 60 * 1000) return "1分钟前"

                                return `${Math.round((Date.parse(nowDay_time) - time01 * 1000) / 1000 / 60)}分钟前`
                            } else {
                                if (timeArr[0][3] > 0 && timeArr[0][3] < 12) {
                                    return `上午 ${timeArr[0][3]}:${timeArr[0][4]}`
                                } else if (timeArr[0][3] >= 12 && timeArr[0][3] <= 14) {
                                    return `中午 ${timeArr[0][3]}:${timeArr[0][4]}`
                                } else if (timeArr[0][3] > 14 && timeArr[0][3] <= 18) {
                                    return `下午 ${timeArr[0][3]}:${timeArr[0][4]}`
                                } else if (timeArr[0][3] > 18 && timeArr[0][3] < 24) {
                                    return `晚上 ${timeArr[0][3]}:${timeArr[0][4]}`
                                }
                            }
                        } else if (stampTransDay(time01 + 60 * 60 * 24) == nowDate) {
                            // 是否为昨天
                            return `昨天 ${timeArr[0][3]}:${timeArr[0][4]}`
                        } else {
                            // 今年里的不是今天和昨天
                            return `${timeArr[0][1]}月${timeArr[0][2]}日  ${timeArr[0][3]}:${timeArr[0][4]}`
                        }
                    } else {
                        return `${timeArr[0][0]}年${timeArr[0][1]}月${timeArr[0][2]}日  ${timeArr[0][3]}:${timeArr[0][4]}`
                    }
                } else {
                    // 是否为今年
                    if (nowDate.slice(0, 4) == item01.slice(0, 4)) {
                        return `${timeArr[0][1]}月${timeArr[0][2]}日  ${timeArr[0][3]}:${timeArr[0][4]}`
                    } else {
                        return `${timeArr[0][0]}年${timeArr[0][1]}月${timeArr[0][2]}日  ${timeArr[0][3]}:${timeArr[0][4]}`
                    }
                }
            } else {
                // 是否为同年
                if (item03 == item04) {
                    // 是否为今年
                    if (nowDate.slice(0, 4) == item01.slice(0, 4)) {
                        // 是否为今天
                        if (nowDate == stampTransDay(time01)) {
                            let nowDay_time: any = new Date()

                            if (Date.parse(nowDay_time) - time01 * 1000 < 60 * 60 * 1000) {
                                if ((Date.parse(nowDay_time) - time01 * 1000) < 60 * 1000) return "1分钟前"

                                return `${Math.round((Date.parse(nowDay_time) - time01 * 1000) / 1000 / 60)}分钟前`
                            } else {
                                if (timeArr[0][3] > 0 && timeArr[0][3] < 12) {
                                    return `上午 ${timeArr[0][3]}:${timeArr[0][4]}`
                                } else if (timeArr[0][3] >= 12 && timeArr[0][3] <= 14) {
                                    return `中午 ${timeArr[0][3]}:${timeArr[0][4]}`
                                } else if (timeArr[0][3] > 14 && timeArr[0][3] <= 18) {
                                    return `下午 ${timeArr[0][3]}:${timeArr[0][4]}`
                                } else if (timeArr[0][3] > 18 && timeArr[0][3] < 24) {
                                    return `晚上 ${timeArr[0][3]}:${timeArr[0][4]}`
                                }
                            }
                        } else if (stampTransDay(time01 + 60 * 60 * 24) == nowDate) {
                            // 是否为昨天
                            return `昨天 ${timeArr[0][3]}:${timeArr[0][4]}`
                        } else {
                            // 今年里的不是今天和昨天
                            return `${timeArr[0][1]}月${timeArr[0][2]}日  ${timeArr[0][3]}:${timeArr[0][4]}`
                        }
                    } else {
                        return `${timeArr[0][0]}年${timeArr[0][1]}月${timeArr[0][2]}日  ${timeArr[0][3]}:${timeArr[0][4]}`
                    }
                } else {
                    // 是否为今年
                    if (nowDate.slice(0, 4) == item01.slice(0, 4)) {
                        return `${timeArr[0][1]}月${timeArr[0][2]}日  ${timeArr[0][3]}:${timeArr[0][4]}`
                    } else {
                        return `${timeArr[0][0]}年${timeArr[0][1]}月${timeArr[0][2]}日  ${timeArr[0][3]}:${timeArr[0][4]}`
                    }
                }
            }
        }
    }
}

/**
 * 处理会话界面时间（接单系统）
*/
export const dealConversationTime = function (time: number) {
    if (time) {
        let nowDate = stampTransDay(new Date(), "nowDate")  // 当前日期

        let date = new Date(time * 1000)
        let Y = date.getFullYear()
        let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
        let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
        let h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
        let m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()

        // 是否为今天
        if (nowDate == stampTransDay(time)) {
            if (Number(h) > 0 && Number(h) < 12) {
                return `上午 ${h}:${m}`
            } else if (Number(h) >= 12 && Number(h) <= 14) {
                return `中午 ${h}:${m}`
            } else if (Number(h) > 14 && Number(h) <= 18) {
                return `下午 ${h}:${m}`
            } else if (Number(h) > 18 && Number(h) < 24) {
                return `晚上 ${h}:${m}`
            }
        } else if (stampTransDay(time + 60 * 60 * 24) == nowDate) {
            // 是否为昨天
            return `昨天 ${h}:${m}`
        } else if (nowDate.slice(0, 4) == stampTransDay(time).slice(0, 4)) {
            // 是否今年
            return `${M}月${D}日 ${h}:${m}`
        } else {
            return `${Y}年${M}月${D}日 ${h}:${m}`
        }
    } else {
        return ""
    }
}


